import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import steps from './onboardingSteps.js';
import BackToConversation from '../backToConversation.jsx';
import viewStatuses from '../viewStatus.js';
import { trackEvent } from '../../services/trackingService.js';
import { viewStatus as viewStatusPropType } from '../safeTradePropTypes.js';

import { role as rolePropType } from '../userPropTypes.js';

function track(stepNum) {
    const oneIndexedNumber = stepNum + 1;

    let flag;
    if (stepNum === 0) {
        flag = 'start';
    } else if (stepNum === steps.length - 1) {
        flag = 'success';
    }

    trackEvent(`trade.show-onboarding.step-${oneIndexedNumber}`, flag);
}

class Onboarding extends PureComponent {
    constructor() {
        super();

        this.state = {
            stepNum: 0,
        };

        this.nextStep = this.nextStep.bind(this);
    }

    componentDidMount() {
        track(this.state.stepNum);
    }

    nextStep(e) {
        e.preventDefault();
        const nextStepNum = this.state.stepNum + 1;
        track(nextStepNum);

        this.setState({
            stepNum: nextStepNum,
        });
    }

    renderProgress() {
        const { stepNum } = this.state;
        const currentStep = steps[stepNum];

        return steps.filter(step => step.showProgress).map((step, index) => (
            <svg key={index} className="valign-middle" width="16" height="16">
                <use
                    xlinkHref={
                        step === currentStep
                            ? '#icon-progress-dot-focus'
                            : '#icon-progress-dot'
                    }
                />
            </svg>
        ));
    }

    renderLink() {
        const { viewStatus, role } = this.props;
        const { stepNum } = this.state;
        const isLastStep = stepNum === steps.length - 1;
        const text = steps[stepNum].nextButtonText;

        if (isLastStep) {
            let goToStatus = true;
            let buttonText;

            if (role === 'BUYER') {
                if (viewStatus === viewStatuses.NOT_STARTED) {
                    goToStatus = false;
                    buttonText = 'Start Trygg betaling';
                } else {
                    buttonText = 'Gå tilbake til Trygg betaling';
                }
            } else if (viewStatus === viewStatuses.AGREEMENT_SENT) {
                buttonText = 'Les avtaleforslag';
            } else if (viewStatus === viewStatuses.NOT_STARTED) {
                buttonText = 'Gå tilbake til samtalen';
            } else {
                buttonText = 'Gå tilbake til Trygg betaling';
            }

            const href = goToStatus ? '/status' : '/start-trygg-betaling';

            return (
                <Link to={href} className="button r-size1of3 primary">
                    {buttonText}
                </Link>
            );
        }

        return (
            <a
                href="#"
                className="button r-size1of3 primary"
                onClick={this.nextStep}
            >
                {text}
            </a>
        );
    }

    render() {
        const { stepNum } = this.state;
        const currentStep = steps[stepNum];
        const imageSrc = `/static/images/safe-trade/onboarding${stepNum}.svg`;

        return (
            <div>
                <BackToConversation />
                <div className="centerify">
                    <h1 className="t2">FINN Trygg betaling</h1>
                    <div className="r-pbl">
                        {currentStep.topText && <p>{currentStep.topText}</p>}
                        <img src={imageSrc} style={{ maxHeight: '110px' }} />
                        {currentStep.body && <p>{currentStep.body}</p>}
                        {currentStep.showProgress && this.renderProgress()}
                        <div className="ptl phl">
                            {currentStep.showFeeDisclaimer && (
                                <p>
                                    Tjenesten koster 2,5% av avtalt pris for
                                    varen. Dette betales av kjøper.
                                </p>
                            )}
                            {this.renderLink()}
                            {currentStep.showCancel && (
                                <div className="r-mtl">
                                    <Link to="/samtale">LUKK</Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Onboarding.propTypes = {
    viewStatus: viewStatusPropType.isRequired,
    role: rolePropType.isRequired,
};

function mapStateToProps(state) {
    return {
        viewStatus: state.safeTrade.viewStatus,
        role: state.user.role,
    };
}

export default connect(mapStateToProps)(Onboarding);



// WEBPACK FOOTER //
// ./safeTrade/onboarding/onboarding.jsx